import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';

const themeClasses = {
  cyan: {
    code: 'from-[var(--color-primary)] to-[var(--bg-hover)]',
    title: 'text-[var(--color-primary)]',
    description: 'text-[var(--color-muted)]',
    accent: 'bg-[var(--color-primary)]',
    button: 'bg-[var(--color-primary)] hover:bg-[var(--bg-hover)] focus-visible:ring-[var(--color-primary)]',
  },
  orange: {
    code: 'from-[var(--color-primary)] via-[var(--bg-hover)] to-[var(--color-orange)]',
    title: 'text-[var(--color-primary)]',
    description: 'text-[var(--color-muted)]',
    accent: 'bg-[var(--color-orange)]',
    button: 'bg-[var(--color-primary)] hover:bg-[var(--bg-hover)] focus-visible:ring-[var(--color-orange)]',
  },
};

const ErrorState = ({
  code,
  title,
  description,
  actionTo,
  actionLabel,
  tone = 'cyan',
}) => {
  const reduceMotion = useReducedMotion();
  const theme = themeClasses[tone] || themeClasses.cyan;

  return (
    <div className="flex min-h-[72vh] items-center justify-center px-4 py-10">
      <motion.div
        initial={reduceMotion ? false : { opacity: 0, y: 20, scale: 0.98 }}
        animate={reduceMotion ? false : { opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        className="relative w-full max-w-3xl text-center"
      >
        <motion.div
          aria-hidden="true"
          className={`absolute left-1/2 top-0 h-px w-40 -translate-x-1/2 rounded-full ${theme.accent} opacity-70`}
          animate={reduceMotion ? false : { scaleX: [0.5, 1, 0.5], opacity: [0.35, 0.8, 0.35] }}
          transition={{ duration: 3.6, repeat: Infinity, ease: 'easeInOut' }}
        />

        <div className="relative">
          <motion.p
            className={`bg-gradient-to-br ${theme.code} mb-5 bg-clip-text text-8xl font-black leading-none text-transparent sm:text-[9.5rem] lg:text-[11rem]`}
            animate={reduceMotion ? false : { y: [0, -5, 0] }}
            transition={{ duration: 4.5, repeat: Infinity, ease: 'easeInOut' }}
          >
            {code}
          </motion.p>
          <h1 className={`mb-4 text-3xl font-extrabold ${theme.title} sm:text-4xl`}>
            {title}
          </h1>
          <p className={`mx-auto mb-9 max-w-xl text-base leading-7 ${theme.description} sm:text-lg`}>
            {description}
          </p>

          <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to={actionTo}
              className={`inline-flex min-h-[50px] w-full items-center justify-center rounded-lg px-7 py-3 text-base font-bold text-white shadow-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 sm:w-auto ${theme.button}`}
            >
              {actionLabel}
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ErrorState;
